import { inr } from "@/lib/fmt";

export const money = (n) => (n == null ? "\u2014" : inr(Math.round(n)));
export const x2 = (n) => (n == null ? "\u2014" : `${n.toFixed(2)}x`);
export const num = (n) => (n == null ? "\u2014" : Number(n).toLocaleString("en-IN"));
export const monthLabel = (m) => new Date(`${m}-01T00:00:00`).toLocaleDateString("en-IN", { month: "short", year: "2-digit" });
export const pct = (a, b) => (a == null || !b ? null : ((a - b) / Math.abs(b)) * 100);
export const roasTone = (r, t) => (r == null ? "" : t ? (r >= t ? "text-[var(--ok)]" : "text-[var(--breach)]") : "");

const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
const istToday = () => { const [y, m, dd] = new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" }).split("-").map(Number); return new Date(y, m - 1, dd); };
export function presetRange(key) {
  const t = istToday();
  const first = (y, m) => new Date(y, m, 1);
  const y = t.getFullYear(), m = t.getMonth();
  switch (key) {
    case "this_month": return [iso(first(y, m)), iso(t)];
    case "last_month": return [iso(first(y, m - 1)), iso(new Date(y, m, 0))];
    case "3m": return [iso(first(y, m - 2)), iso(t)];
    case "6m": return [iso(first(y, m - 5)), iso(t)];
    case "12m": return [iso(first(y, m - 11)), iso(t)];
    case "ytd": return [iso(first(y, 0)), iso(t)];
    case "all": return [iso(first(y - 3, m)), iso(t)];
    default: return null;
  }
}
export const PRESETS = [["this_month", "This month"], ["last_month", "Last month"], ["3m", "3 months"], ["6m", "6 months"], ["12m", "12 months"], ["ytd", "This year"], ["all", "All time"]];

export function Delta({ cur, prev, invert, testid }) {
  const p = pct(cur, prev);
  if (p == null || !isFinite(p)) return null;
  const good = invert ? p < 0 : p > 0;
  return (
    <span className={`text-[10px] tabular-nums ${Math.abs(p) < 0.5 ? "text-[var(--text-dim)]" : good ? "text-[var(--ok)]" : "text-[var(--breach)]"}`} data-testid={testid}>
      {p > 0 ? "\u25B2" : p < 0 ? "\u25BC" : ""} {Math.abs(p).toFixed(0)}%
    </span>
  );
}
